const swalMessages = {
  REPEAT_MESSAGE_ERROR: {
    title: 'Upsss!!!!',
    text: 'Ya existe',
    icon: 'warning',
    button: 'Cerrar!',
    dangerMode: true,
  },
  DATA_STUDIO_ERROR: {
    title: 'Upsss!!!!',
    text: 'No se pudo refrescar el token Auth, contacte al administrador',
    icon: 'warning',
    button: 'Cerrar!',
    dangerMode: true,
  },
  ASSIGNMENT_ESTABLICHED: {
    title: 'Upsss!!!!',
    text: 'Ya asignado',
    icon: 'warning',
    button: 'Cerrar!',
    dangerMode: true,
  },
  DELETE_CONFIRM: {
    title: '¿ Estás seguro ?',
    icon: 'warning',
    buttons: true,
    dangerMode: true,
  },
  UNLOCK_CONFIRM: {
    title: '¿ Estás seguro de desbloquear a este usuario?',
    icon: 'warning',
    buttons: true,
    dangerMode: true,
  },
  UPDATE_CONFIRM: {
    title: '¿ Estás seguro ?',
    text:
      'Estas acción actualiza todos los atributos del segmento, deberás actualizar todas las valoraciónes. ¿ Estas seguro ?.',
    icon: 'warning',
    buttons: true,
    dangerMode: true,
  },
  UPDATE_CONFIRM_VALUE_MAP: {
    title: 'Presta Atención',
    text:
      'Estas acción actualiza el Mapa de Valor seleccionado y el listado de vehículos según la ultima valoración, unidades vendidas, precios etc. ¿Deseas continuar? ',
    icon: 'info',
    buttons: true,
    dangerMode: false,
  },
  DELETE_ERROR: {
    title: 'Upsss!!!!',
    text:
      'No puedes realizar esta acción primero debes eliminar la asociación ',
    icon: 'warning',
    button: 'Cerrar!',
    dangerMode: true,
  },
  SUCCESSFUL_MESSAGE: {
    title: 'Bien!!!!',
    text: 'Creado exitosamente',
    icon: 'success',
    button: 'OK!',
  },
  WARNING_SEGMENT: {
    title: 'Upsss!!!!',
    text: 'Segmento Existente',
    icon: 'warning',
    button: 'Cerrar!',
    dangerMode: true,
  },
  WARNING_SEGMENT_ESTABLICHED: {
    title: 'Upsss!!!!',
    text: 'Segmento Existente',
    icon: 'warning',
    button: 'Cerrar!',
    dangerMode: true,
  },
  WARNING_GENERAL: {
    title: 'Upsss!!!!',
    text: 'Notifición Error',
    icon: 'warning',
    button: 'Cerrar!',
    dangerMode: true,
  },
  WARNING_DATASTUDIO: {
    title: 'Upsss!!!!',
    text: 'La Url o el nombre ya se encuentran asignados',
    icon: 'warning',
    button: 'Cerrar!',
    dangerMode: true,
  },
  NOT_PERMITS: {
    title: 'Upsss!!!!',
    text: 'Algo salio revisa tus permisos',
    icon: 'warning',
    button: 'Cerrar!',
    dangerMode: true,
  },
  GENERAL_ERROR: {
    title: 'Upsss!!!!',
    text: 'Parece que tenemos un error',
    icon: 'warning',
    button: 'Cerrar!',
    dangerMode: true,
  },
  LAUNCH_ERROR: {
    title: 'Upsss!!!!',
    text: 'No puedes realizar mas de 12 lanzamientos',
    icon: 'warning',
    button: 'Cerrar!',
    dangerMode: true,
  },
  RECOVER_MESSAGE: 'Revisa tu correo electrónico',
  RECOVER_UPDATE_SUCCESS: {
    title: 'Actualiación Exitosa!',
    text: 'Inicia sesión.',
    type: 'success',
    timer: 3000,
  },
  SUCCESFUL_UPDATE: {
    title: 'Actualización Exitosa!',
    icon: 'success',
    button: 'OK!',
    timer: 3000,
  },
  SUCCESFUL_REJECT: {
    title: 'Rechazo Exitoso!',
    icon: 'success',
    button: 'OK!',
    timer: 3000,
  },
  SUCCESSFUL_APPROVAL: {
    title: 'Aprobación Exitosa!',
    icon: 'success',
    button: 'OK!',
    timer: 3000,
  },
  SUCCEFUL_DELETE: {
    title: 'Eliminado Exitoso!',
    icon: 'success',
    button: 'OK!',
    timer: 3000,
  },
  DELETE_REPORT_CONFIRM: {
    title: '¿ Estás seguro ?',
    text:
      'Al eliminar, Automaticamente todos los usuarios quedarán sin acceso al reporte',
    icon: 'warning',
    buttons: true,
    dangerMode: true,
  },
  ARCHIVE_CONFIRM: {
    title: '¿ Estás seguro de archivar ?',
    icon: 'warning',
    buttons: true,
    dangerMode: true,
  },
  UNARCHIVE_CONFIRM: {
    title: '¿ Estás seguro de desarchivar ?',
    icon: 'warning',
    buttons: true,
    dangerMode: true,
  },
  ACCEPT_CONFIRM: {
    title: '¿ Estás seguro de aprobar ?',
    icon: 'success',
    buttons: true,
    dangerMode: false,
  },
  ACCEPT_TEST_CONFIRM: {
    title: '¿Estás seguro de solicitar prueba?',
    icon: 'warning',
    buttons: true,
    dangerMode: false,
  },
  ASSIGN_CONFIRM: {
    title: '¿Estás seguro de asignar esta unidad?',
    icon: 'warning',
    buttons: true,
    dangerMode: false,
  },
  REJECT_CONFIRM: {
    title: '¿ Estás seguro de rechazar ?',
    icon: 'warning',
    buttons: true,
    dangerMode: true,
  },
  SUCCESSFUL_SEND: {
    title: '¡ Enviado !, En la espera de aprobación',
    icon: 'success',
    button: 'Ok',
    timer: 3000,
  },
  SUCCESSFUL_EMAIL: {
    title: '¡ Enviado con éxito !',
    icon: 'success',
    button: 'Ok',
    timer: 3000,
  },
  NOT_FOUND: {
    title: 'No se encontraron resultados en la busqueda',
    icon: 'warning',
    button: 'Ok',
    timer: 3000,
  },
  NOT_AVAILABLE: {
    title:
      'La página no está disponible para la unidad de negocio seleccionada',
    icon: 'warning',
    buttons: true,
    dangerMode: true,
  },
  NOT_SELECTED: {
    title:
      'Selecciona 1 socio para generar la evaluación',
    icon: 'warning',
    button: 'ok',
    timer: 3000,
  },
};

export default swalMessages;
